import React, { createRef } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import DefaultFooter from "../CommonUtils/DefaultFooter";
import ConversationListCell from "../LandingPage/ConversationListCell";
import { s360ConfigService } from "../Services/S360Config";

import NewConversationButton from "./NewConversationButton";

import "../LandingPage/LandingPageStyleSheet.css";

function ConversationList(props) {
  const conversationListRef = createRef();

  const conversations = props.sessionsList || [];
  console.log(props, "hello123")

  var activeConversations = s360ConfigService?.config?.sandBox
    ? [
      {
        sessionId: 108254,
        active: true,
        createdOn: 1702275608000,
        updatedOn: 1702275608000,
        lastMessage: { text: "I really appreciate your time I hope we can meet" },
        agentInfo: {
          agentId: 0,
          isActive: false,
        },
      },
      {
        sessionId: 108254,
        active: true,
        createdOn: 1702275608000,
        updatedOn: 1702275608000,
        lastMessage: { text: "Thanks! Happy to discuss further with you." },
        agentInfo: {
          agentId: 0,
          isActive: false,
        },
      },
    ]
    : conversations?.filter((conversation) => conversation.active) ?? [];
  const prevConversations =
    conversations?.filter((conversation) => !conversation.active) ?? [];
  console.log(prevConversations, conversations, "prevConversations")
  const isFetchingConversations = props.isFetchingConversations || false;
  const noConversations = !activeConversations.length && !prevConversations.length;

  const onConversationListScroll = () => {
    let scrollContainer = conversationListRef.current;
    let isBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop === scrollContainer.clientHeight;
    if (isBottom) {
      props.onScrollToBottom();
    }
  };

  return (
    <div
      className="s360-conversation-list-container"
      style={props.config?.customDesign?.conversationListContainer}
    >
      <div
        ref={conversationListRef}
        onScroll={onConversationListScroll}
        className="s360-conversation-list-all-conversations"
      >
        {isFetchingConversations && !s360ConfigService?.config?.sandBox && (
          <div
            className="s360-conversation-history-list-cell-activity-indicator"
            style={
              props.config?.customDesign
                ?.conversatinHistoryListCellActivityIndicator
            }
          >
            <CircularProgress color="inherit" size={20} />
          </div>
        )}
        {activeConversations.length >0 &&<span>Active conversations</span>}
        {activeConversations.map((conversation) => (
          <ConversationListCell
            key={conversation.sessionId + "session-id-cell"}
            config={props.config}
            conversation={conversation}
            landingPageActions={props.landingPageActions}
          />
        ))}
        {prevConversations.length >0 &&<span>Previous conversations</span>}
        {prevConversations.map((conversation) => (
          <ConversationListCell
            key={conversation.sessionId + "session-id-cell"}
            config={props.config}
            conversation={conversation}
            landingPageActions={props.landingPageActions}
          />
        ))}

        {!isFetchingConversations && noConversations && (
          <div className="s360-conversation-list-no-conversation">
            {props.config.configDetails.noconversation}
          </div>
        )}

        <div>
          {(props.config.configDetails.startNewSession ||
            !!props.areAllPreviousSessionsClosed) && (
            <NewConversationButton
              config={props.config}
              landingPageActions={props.landingPageActions}
              activeSession={props.activeSession}
            />
          )}
        </div>
      </div>
      <DefaultFooter isInAgentHistoryPage={true} />
    </div>
  );
}
export default ConversationList;
